import { mapGetters } from 'vuex'

/**
 * This gives some utilities that can be used by Sidebar and its child components
 */
export default {
  computed: {
    ...mapGetters(['goalById', 'keyResultById', 'initiativeById']),
    ...mapGetters('idea', ['ideaById', 'ideaListById']),
    ...mapGetters('project', ['projectById'])
  },
  methods: {
    isActiveTeam(teamId, includeProjectInitiatives = false) {
      const params = this.$route.params
      let activeTeamId = params.teamId
      if (params.goalId) {
        activeTeamId = this.goalById(params.goalId)?.teamId
      } else if (params.krId) {
        activeTeamId = this.keyResultById(params.krId)?.teamId
      } else if (params.initiativeId) {
        const initiative = this.initiativeById(params.initiativeId)
        activeTeamId =
          includeProjectInitiatives || !initiative?.projectId ? initiative?.teamId : null
      } else if (params.listId) {
        activeTeamId = this.ideaListById(params.listId)?.teamId
      } else if (params.ideaId) {
        const idea = this.ideaById(params.ideaId)
        if (idea) {
          activeTeamId = this.ideaListById(idea.listId)?.teamId
        }
      }
      return +teamId === +activeTeamId
    },
    isActiveProject(projectId) {
      const params = this.$route.params
      let activeProjectId
      if (params.projectId) {
        activeProjectId = params.projectId
      } else if (params.initiativeId) {
        activeProjectId = this.initiativeById(params.initiativeId)?.projectId
      }
      return activeProjectId === projectId
    }
  }
}
